module.exports = __webpack_public_path__ + "media/unipod/delivery_installation_2-5c0385a6.jpg";